import {
  BASE_SEPOLIA_E2E_ACCOUNT_ADDRESS,
  SOLANA_DEVNET_E2E_ACCOUNT_ADDRESS,
} from 'apps/cdp-web-demo/app/data/addresses';
import { AccountCreationType } from 'apps/cdp-web-demo/app/types';

import { SendEvmEoaTransaction } from './SendEvmEoaTransaction';
import { SendEvmSmartTransaction } from './SendEvmSmartTransaction';
import { SendSolanaTransaction } from './SendSolanaTransaction';

function isEvmAddress(address?: string): address is `0x${string}` {
  return address?.startsWith('0x') ?? false;
}

type Props = {
  accountCreationType: AccountCreationType;
  userAddress?: string;
  onClick?: () => void;
  onSuccess?: (hash: string) => void;
  onError?: (error: Error) => void;
};

function SendTransaction({ accountCreationType, userAddress, onSuccess, onError, onClick }: Props) {
  const isSolana = accountCreationType === 'solana';

  if (isSolana) {
    return (
      <SendSolanaTransaction
        destinationAddress={SOLANA_DEVNET_E2E_ACCOUNT_ADDRESS}
        sourceAddress={userAddress}
        onClick={onClick}
        onError={onError}
        onSuccess={onSuccess}
      />
    );
  }

  if (!isEvmAddress(userAddress)) {
    return null;
  }

  if (accountCreationType === 'evm-smart') {
    return (
      <SendEvmSmartTransaction
        destinationAddress={BASE_SEPOLIA_E2E_ACCOUNT_ADDRESS}
        sourceAddress={userAddress}
        onClick={onClick}
        onError={onError}
        onSuccess={onSuccess}
      />
    );
  }

  return (
    <SendEvmEoaTransaction
      destinationAddress={BASE_SEPOLIA_E2E_ACCOUNT_ADDRESS}
      sourceAddress={userAddress}
      onClick={onClick}
      onError={onError}
      onSuccess={onSuccess}
    />
  );
}

export { SendTransaction };
